import { render, staticRenderFns } from "./MarketingStockAdmin.vue?vue&type=template&id=f02712fc&scoped=true"
import script from "./MarketingStockAdmin.vue?vue&type=script&lang=js"
export * from "./MarketingStockAdmin.vue?vue&type=script&lang=js"
import style0 from "./MarketingStockAdmin.vue?vue&type=style&index=0&id=f02712fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02712fc",
  null
  
)

export default component.exports